import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AccountService {
  constructor(private readonly http: HttpClient) {}

  disableAccountStatus(userId: string): Observable<any> {
    return this.http.patch<any>(`${environment.url}/user/disable/${userId}`, {});
  }
}
